import PageComponent from '../PageComponent';
import DateFieldErgonomics from '../date/DateFieldErgonomics';

export default class Global extends PageComponent {
    init() {
        this.ready();
    }

    ready() {
        // DateFieldErgonomics.ready()

        $('.toggle-pw-visibility').on('click', function () {
            let pwField = $(this).siblings('input'),
                type = pwField.attr("type");

            if (type === 'password') {
                pwField.attr("type", "text");
            } else {
                pwField.attr("type", "password");
            }
        });
    }
}
